import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BN } from 'bn.js';
import * as nearAPI from 'near-api-js';
import { connect, KeyPair, WalletConnection } from 'near-api-js';
import { AccountBalance } from 'near-api-js/lib/account';
import { parseNearAmount } from 'near-api-js/lib/utils/format';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NearApiServiceService {
  near: nearAPI.Near | undefined;
  wallet: nearAPI.WalletConnection | undefined;
  balance: BehaviorSubject<AccountBalance | undefined> = new BehaviorSubject<
    AccountBalance | undefined
  >(undefined);
  user: BehaviorSubject<string | undefined> = new BehaviorSubject<
    string | undefined
  >(undefined);
  private systemAddress: string | undefined;
  constructor() {}
  async initWallet(
    appName: string,
    blockchainConfig: any,
    accountBlockchainData: any
  ): Promise<void> {
    const keyStore = new nearAPI.keyStores.BrowserLocalStorageKeyStore();
    const data = accountBlockchainData.blockchainData.NEAR;
    const metaParsed = JSON.parse(decrypt(data.meta, environment.privateKey));
    await keyStore.setKey(
      blockchainConfig.networkId,
      data.blockchainId,
      KeyPair.fromString(metaParsed.secret)
    );
    this.systemAddress = blockchainConfig.address;
    const near = await connect({
      headers: {},
      keyStore, // instance of BrowserLocalStorageKeyStore
      networkId: blockchainConfig.networkId,
      nodeUrl: blockchainConfig.nodeUrl,
      walletUrl: blockchainConfig.walletUrl,
      helperUrl: blockchainConfig.helperUrl,
    });

    window.localStorage.setItem(
      appName + '_wallet_auth_key',
      JSON.stringify({
        accountId: data.blockchainId,
        allKeys: metaParsed.allKeys,
      })
    );

    this.wallet = new WalletConnection(near, appName);
  }

  useDeposit(amount: string): void {
    let amountBN: string | null = parseNearAmount(amount);
    if (this.wallet && this.systemAddress && amountBN)
      this.wallet
        .account()
        .sendMoney(this.systemAddress, new BN(amountBN))
        .then();
  }
  // async initNear(): Promise<void> {
  //   const { connect, keyStores } = nearAPI;
  //   this.near = await connect({
  //     headers: {},
  //     networkId: 'testnet',
  //     keyStore: new keyStores.BrowserLocalStorageKeyStore(),
  //     nodeUrl: 'https://rpc.testnet.near.org',
  //     walletUrl: 'https://wallet.testnet.near.org',
  //     helperUrl: 'https://helper.testnet.near.org',
  //   });
  //   this.wallet = new WalletConnection(this.near, null);
  //   if (this.wallet.isSignedIn()) {
  //     const accountId = this.wallet?.account().accountId;
  //     this.user.next(accountId);
  //     this.near.account(accountId).then((res) => {
  //       res.getAccountBalance().then((res) => this.balance.next(res));
  //     });
  //   }
  // }
  // loginWallet(contract: string) {
  //   this.wallet?.requestSignIn({ contractId: contract });
  // }
  logOut(): void {
    this.wallet?.signOut();
    this.balance.next(undefined);
    this.user.next(undefined);
  }
  // createAccount(): void {
  //   window.open('https://wallet.testnet.near.org/create');
  // }
}
